import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import ApiEnter from "@/api/ApiEnter";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import DataRegions from "@/data/AdminPanel/DataRegions";
import ApiRegion from "@/api/ApiRegion";
import sweetalert from "sweetalert";
import { Getter } from "vuex-class";
import EUserEnum from "@/struct/user/EUserEnum";
let RegionsList = class RegionsList extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = DataRegions.Breadcrumbs;
        this.TableHeaders = DataRegions.TableHeaders;
        this.TableItems = [];
        this.HasRequest = false;
    }
    CanAddAndEditAccess() {
        return (this.GetCurrentSessionUser != undefined &&
            (this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Admin ||
                this.GetCurrentSessionUser.system_role ==
                    EUserEnum.SystemRole.SuperAdmin ||
                this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Editor));
    }
    CanDeleteAccess() {
        return (this.GetCurrentSessionUser != undefined &&
            (this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.Admin ||
                this.GetCurrentSessionUser.system_role ==
                    EUserEnum.SystemRole.SuperAdmin));
    }
    async getRegions() {
        this.HasRequest = true;
        try {
            this.TableItems = await ApiRegion.GetRegions();
        }
        catch (e) {
            console.error(e);
        }
        this.HasRequest = false;
    }
    async ChangeActivity(item) {
        try {
            const response = await ApiRegion.UpdateRegionActivity(item.is_active ? 1 : 0, ApiEnter.CurrentSessionUUID, item.uuid);
            if (typeof response == "boolean") {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_updated"),
                    icon: "success",
                }).then(() => {
                    this.getRegions();
                });
            }
            else {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
            }
        }
        catch (e) {
            console.error(e);
            await sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            });
        }
    }
    async DeleteItem(regionUUID) {
        sweetalert({
            title: this.$t("general.confirm"),
            text: this.$t("roaming.confirm_delete"),
            buttons: [
                this.$t("general.no"),
                this.$t("general.yes"),
            ],
        }).then(async (isConfirm) => {
            if (isConfirm == true) {
                const response = await ApiRegion.DeleteRegion(ApiEnter.CurrentSessionUUID, regionUUID);
                if (typeof response == "boolean") {
                    await sweetalert({
                        title: this.$t("general.success"),
                        text: this.$t("general.success_deleted"),
                        icon: "success",
                    });
                    await this.getRegions();
                }
                else {
                    await sweetalert({
                        title: this.$t("general.error"),
                        text: this.$t("general.request_error"),
                        icon: "info",
                    });
                }
            }
        });
    }
    mounted() {
        this.getRegions();
    }
};
__decorate([
    Getter("getCurrentSessionUser")
], RegionsList.prototype, "GetCurrentSessionUser", void 0);
RegionsList = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], RegionsList);
export default RegionsList;
